import { submit_form } from "./functions";
import initOverlayer from "../general/overlayer";
import initCookieBanner from "../general/cookieBanner";
import initApplication from "./app";

export let ajaxBaseUrl = "";

export const appList = {
  pagingSize: 5 /* will change dynamic depending on available screen height */,
  elmHeight: 78 /* size of a list element */,
  wrapperOffset: 322 /* space elements above and under list need */,
  extraOffsetNoBtns: 55 /* more room if no buttons under a list */,
  current: 0 /* possition of the pager */,
  lastItem: 0 /* last known position */,
  resetCurrent: true,
  minimumDisplayWidth: 1025 /* exclude mobile and tablets for paging */,
};

export const startUp = () => {
  if (initVals.webRoot && initVals.webRoot != "") {
    ajaxBaseUrl = "/" + initVals.webRoot;
  }

  const navicon = document.querySelectorAll("#navicon, nav a.close");
  navicon.forEach((item) => {
    item.addEventListener("click", handleClickNavicon);
  });

  const handleClickNavicon = (e) => {
    e.preventDefault();

    const body = document.body;

    if (body.classList.contains("closed")) {
      body.classList.add("open");
      body.classList.remove("closed");
    } else {
      body.classList.add("closed");
      body.classList.remove("open");
    }
  };

  const logo = document.querySelector("#logo");
  if (logo) {
    logo.addEventListener("click", (e) => {
      e.preventDefault();
      window.location = ajaxBaseUrl + "/";
    });
  }

  //GENERAL FORM SCRIPTS
  /*const form = document.querySelectorAll("form");
	if (form) {
		form.forEach(form => { 
			form.addEventListener("submit", (e) => { 
				e.preventDefault();
				submit_form(form);
			});
		});

		//remove browser default error input popups
		document.addEventListener('invalid', (function(){
			return function(e) {
			  e.preventDefault();

			  e.target.classList.add("error");
			  const closestLabel = e.target.closest("label");
			  if (closestLabel) { closestLabel.classList.add("error"); }
			};
		})(), true);

		//honeypot - extra bot challange
		const h8pt = document.querySelectorAll("input[name='h8pt']");
		const formInputs = document.querySelectorAll("input");
		if (h8pt && h8pt.length > 0) {
			setTimeout(function(){
				formInputs.forEach(input => { 
					input.addEventListener("click", (e) => {
						h8pt.forEach(inputHoneypot => {
							inputHoneypot.value = "";
						});
					});
				});
			}, 3000);
		}
	}*/

  //input - remove class error on focus
  const name = document.querySelectorAll("*[name]");
  name.forEach((item) => {
    item.addEventListener("focus", (e) => handleNameFocusAndChange(e));
    item.addEventListener("change", (e) => handleNameFocusAndChange(e));
  });

  const handleNameFocusAndChange = (e) => {
    e.target.classList.remove("error");
    const groups = e.target.closest("label");

    if (groups) {
      groups.classList.remove("error");
    }
  };

  //ENABLE RECAPTCHA
  if (initVals.recaptchaKey) {
    if (document.querySelector("#form")) {
      recaptchaSubmit("form");
    }
  }

  //overlayer
  initOverlayer();

  //cookie banner
  initCookieBanner();

  //init application
  initApplication();
};
